import { localizedPath } from '#app/utils/i18n.ts'
import { getDomainUrl } from '#app/utils/misc.tsx'
import { Outlet } from 'react-router'
import { type Route } from './+types/blog._layout.ts'

export async function loader({ request }: Route.LoaderArgs) {
	const siteUrl = (process.env.APP_URL || getDomainUrl(request)).replace(
		/\/$/,
		'',
	)

	return { siteUrl }
}

export const meta: Route.MetaFunction = ({ params, data }) => {
	if (!data) return []
	const lang = params.lang || 'de'
	const feedUrl = `${data.siteUrl}${localizedPath(lang, '/blog/feed.xml')}`
	return [
		{
			tagName: 'link' as const,
			rel: 'alternate',
			type: 'application/rss+xml',
			title: 'Blog | Open Sourced',
			href: feedUrl,
		},
	]
}

export default function BlogLayout() {
	return <Outlet />
}
